import { useFetch } from "../useFetch";
import type {
	ScheduleResponse,
	CreateSchedulePayload,
	UpdateSchedulePayload,
	ToggleScheduleStatusPayload,
} from "../../core/types/services";

// ============================================
// GET ALL SCHEDULES
// ============================================
export function useSchedules() {
	return useFetch<ScheduleResponse[]>({
		endpoint: "/schedules",
		method: "GET",
	});
}

// ============================================
// GET SCHEDULE BY ID
// ============================================
export function useSchedule(id: number) {
	return useFetch<ScheduleResponse>({
		endpoint: `/schedules/${id}`,
		method: "GET",
	});
}

// ============================================
// GET SCHEDULES BY PROVIDER
// ============================================
export function useSchedulesByProvider(providerId: number) {
	return useFetch<ScheduleResponse[]>({
		endpoint: `/schedules/provider/${providerId}`,
		method: "GET",
	});
}

// ============================================
// GET AVAILABLE SCHEDULES BY PROVIDER
// ============================================
// Este endpoint suele usarse para ver huecos libres o lógica específica
export function useAvailableSchedulesByProvider(providerId: number) {
	return useFetch<ScheduleResponse[]>({
		endpoint: `/schedules/${providerId}/available`,
		method: "GET",
	});
}

// ============================================
// CREATE SCHEDULE
// ============================================
export function useCreateSchedule() {
	const fetch = useFetch<ScheduleResponse, CreateSchedulePayload>({
		endpoint: "/schedules",
		method: "POST",
		auto: false,
	});

	const create = (data: CreateSchedulePayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, create };
}

// ============================================
// UPDATE SCHEDULE
// ============================================
export function useUpdateSchedule(id: number) {
	const fetch = useFetch<ScheduleResponse, UpdateSchedulePayload>({
		endpoint: `/schedules/${id}`,
		method: "PATCH",
		auto: false,
	});

	const update = (data: UpdateSchedulePayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, update };
}

// ============================================
// DEACTIVATE / ACTIVATE SCHEDULE
// ============================================
export function useDeactivateSchedule(id: number) {
	const fetch = useFetch<ScheduleResponse, ToggleScheduleStatusPayload>({
		endpoint: `/schedules/${id}/deactivate`,
		method: "PATCH",
		auto: false,
	});

	const deactivate = (isActive: boolean) => {
		return fetch.execute({ body: { isActive } });
	};

	return { ...fetch, deactivate };
}

// ============================================
// DELETE SCHEDULE (Opcional)
// ============================================
export function useDeleteSchedule() {
	const fetch = useFetch<{ message: string }>({
		endpoint: "/schedules",
		method: "DELETE",
		auto: false,
	});

	const remove = (id: number) => {
		return fetch.execute({ endpoint: `/schedules/${id}` });
	};

	return { ...fetch, remove };
}
